import { Component } from '@angular/core';

@Component({
  selector: 'ocp-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {}
